import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import GLSummaryDetailCell from 'src/components/custom-cells/GLSummaryDetailCell';
import GLSummaryDetailHeaderCell from 'src/components/custom-cells/GLSummaryDetailHeaderCell';
import RemainingGlBalanceCell from 'src/components/custom-cells/RemainingGlBalanceCell';
import useActionRequiredInvoices from 'src/hooks/useActionRequiredInvoices';
import GLCodeField from 'src/sections/action_required_invoices/glSummaryColumns/GLCodeField';

export const useMultiPeriodGLSummaryColumns = () => {
  const { usesBudgets } = useActionRequiredInvoices();

  const columns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'expanded',
        component: GLSummaryDetailCell,
        menu: false,
        headerCell: GLSummaryDetailHeaderCell,
        width: 44,
        minResizableWidth: 44,
      },
      {
        field: 'glCd',
        title: 'GL Code',
        menu: false,
        component: GLCodeField,
        width: 150,
        minResizableWidth: 100,
      },
      {
        field: 'description',
        title: 'Description',
        menu: false,
        width:250,
        minResizableWidth: 200,
        },
      {
        field: 'invoiceType',
        title: 'Accounting Period',
        menu: false,
        width: 150,
        minResizableWidth: 100,
      },
      {
        field: 'poGlGrandTotal',
        title: 'PO GL Total',
        menu: false,
        dataType: 'dollar',
        width: 140,
        format: '{0:c2}',
        minResizableWidth: 100,
      },
      {
        field: 'currentDocGlGrandTotal',
        title: 'Current Doc GL Total',
        menu: false,
        dataType: 'dollar',
        width: 180,
        minResizableWidth: 120,
        format: '{0:c2}',
      },
      {
        field: 'otherDocGlGrandTotal',
        title: 'Other Doc GL Total for PO',
        menu: false,
        dataType: 'dollar',
        width: 180,
        minResizableWidth: 120,
        format: '{0:c2}',
      },
      {
        field: 'glRemainingBudget',
        title: 'Current Forecast Remaining Balance',
        menu: false,
        dataType: 'dollar',
        width: 180,
        minResizableWidth: 120,
        format: '{0:c2}',
      },
      ...(usesBudgets
        ? ([
            {
              field: 'glRemainingInitialBudget',
              title: 'Current Budget Remaining Balance',
              dataType: 'dollar',
              width: 180,
              minResizableWidth: 120,
              format: '{0:c2}',
              menu: false,
            },
          ] as const)
        : []),
    ],
    [usesBudgets]
  );

  return columns;
};

export const useMultiPeriodGLSummarySubColumns = () => {
  const { usesBudgets } = useActionRequiredInvoices();

  const columns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: '',
        title: '',
        menu: false,
        width: 150,
      },
      {
        field: '',
        title: '',
        menu: false,
      },
      {
        field: 'accountingPeriod',
        title: '',
        menu: false,
        width: 150,
      },
      {
        field: 'poGlTotal',
        title: '',
        menu: false,
        dataType: 'dollar',
        format: '{0:c2}',
        width: 140,
      },
      {
        field: 'currentDocGlTotal',
        title: '',
        menu: false,
        dataType: 'dollar',
        width: 180,
        format: '{0:c2}',
      },
      {
        field: 'otherDocGlTotal',
        title: '',
        menu: false,
        dataType: 'dollar',
        width: 180,
        format: '{0:c2}',
      },
      {
        field: 'glRemainingBudget',
        title: '',
        menu: false,
        dataType: 'dollar',
        format: '{0:c2}',
        component: RemainingGlBalanceCell,
        width: 180,
      },
      ...(usesBudgets
        ? ([
            {
              field: 'glRemainingInitialBudget',
              title: '',
              dataType: 'dollar',
              width: 180,
              format: '{0:c2}',
              component: RemainingGlBalanceCell,
              menu: false,
            },
          ] as const)
        : []),
    ],
    [usesBudgets]
  );
  return columns;
};
